<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <section class="">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="text-center">
                    <h1><strong>Add Enrollee Form </strong></h1>
                    <p>
                      (All fields marked with)
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity">Select Sector
                            <span class="text-danger">*</span></label>

                          <!-- Custom sectors for agency 313923 -->
                          <select v-if="is313923" class="form-control" required v-model="register.sector"
                            :disabled="isBHCPFStaff" @change="onSectorChange">
                            <option value="">-- Select --</option>
                            <option value="Basic Healthcare Provision Fund">Basic Healthcare Provision Fund</option>
                            <template v-if="!isBHCPFStaff">
                              <option value="Elderly">Elderly</option>
                              <option value="Orphanage">Orphanage</option>
                              <option value="Vulnerable Sponsored">Vulnerable Sponsored</option>
                            </template>
                            <!-- <option value="Voluntary Contributor">Voluntary Contributor</option> -->
                          </select>

                          <!-- Default sectors for all other agencies -->
                          <select v-else class="form-control" required v-model="register.sector"
                            :disabled="isBHCPFStaff" @change="filterVulnerable">
                            <option :value="sector.name" v-for="sector in sectors" :key="sector.agency_id">
                              {{sector.name}}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Sub-program dropdown (313923 only, hidden for BHCPF) -->
                      <div class="col-md-6" v-if="is313923 && currentSubPrograms.length">
                        <div class="form-group">
                          <label>Sub-Program <span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.sectorType">
                            <option value="">-- Select Sub-Program --</option>
                            <option v-for="sub in currentSubPrograms" :key="sub" :value="sub">{{ sub }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6" v-if="register.sector != 'Voluntary Contributor'">
                        <label>Special Needs <span class="text-danger">*</span></label>
                        <select :required="vulnerables && vulnerables.length > 0" class="form-control"
                          v-model="register.category_of_vulnerable_group">
                          <option :value="vulnerable.name" v-for="vulnerable in vulnerables"
                            :key="vulnerable.agency_id">
                            {{vulnerable.name}}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN <span class="text-danger">*</span></label>
                        <input required type="text" inputmode="numeric" pattern="\d{11}" maxlength="11"
                          class="form-control" v-model="register.nimc_number"
                          @input="register.nimc_number = register.nimc_number.replace(/\D/g, '').slice(0, 11)"
                          placeholder="NIN " />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename"
                          placeholder="Middle Name" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Date of Birth<span class="text-danger">*</span>
                          </label>
                          <small v-if="isChildUnder5Category" class="text-info d-block">
                            Must be under 5 years old
                          </small>
                          <small v-else-if="isAgedCategory" class="text-info d-block">
                            Must be 60 years or older
                          </small>
                          <small v-else-if="isPregnantCategory" class="text-info d-block">
                            Must be at least 13 years old
                          </small>
                        </p>
                        <input type="date" :min="dobMin" :max="dobMax" required class="form-control"
                          v-model="register.dob" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="text" pattern="\d*" class="form-control"
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>


                      <div class="form-group col-md-6" v-if="agency.id == '930972'">
                        <label>Select {{label.place_of_work_label}}
                          <span class="text-danger">*</span>
                        </label>

                        <v-select v-model="register.place_of_work" :options="mdas" label="name"
                          :value="register.place_of_work" @input="getDepts"></v-select>

                        <!-- <select class="form-control" required v-model="register.place_of_work" @change="getDepts">
                          <option :value="mda" v-for="mda in mdas" :key="mda.id">{{mda.name}} </option>
                        </select> -->

                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <small v-if="isPregnantCategory" class="text-info d-block">
                          Locked to Female for Pregnant Women
                        </small>
                        <select class="form-control" required v-model="register.gender" :disabled="isPregnantCategory">
                          <option value="Male" :disabled="isPregnantCategory">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="agency.id != '313923'">
                        <label for="inputCity">HMO <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="register.org_id" required>
                          <option v-for="org in tpas" v-bind:key="org" :value="org.id">
                            {{ org.organization_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">LGA <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="register.sector != 'Voluntary Contributor'">
                        <label>Ward <span class="text-danger">*</span> </label>
                        <select class="form-control" v-model="register.ward" required @change="getProvidersByWards()">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6" v-if="register.sector != 'Voluntary Contributor'">
                        <label for="inputPassword4">Community <span class="text-danger">*</span></label>
                        <input required type="text" class="form-control" v-model="register.community"
                          placeholder="Community Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>
                          Facility for Accessing Health Care

                          <span class="text-danger">*</span>

                          <button @click="getProviders" type="button" class="btn btn-outline-info btn-sm my-1">
                            All
                          </button>
                        </label>
                        <v-select v-model="register.provider_id" :options="providers" label="agency_name"
                          :value="register.provider_id"></v-select>
                        <small v-if="register.localgovt && !(providers || []).length" class="text-muted d-block mt-1">No facility listed for this LGA or ward. Click <b>All</b> to choose from every facility in the state.</small>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Occupation <span class="text-danger">*</span></label>
                        <v-select v-model="register.occupation" :options="occupations" :required="!register.occupation"
                          :value="register.occupation"></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Highest Qualification <span class="text-danger">*</span></label>
                        <v-select v-model="register.education" :options="qualifications" :required="!register.education"
                          :value="register.education"></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="">NA</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address <span class="text-danger">*</span></label>
                        <input required type="text" class="form-control" v-model="register.address"
                          placeholder="1234 Main St" />
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label>Photo
                        <span v-if="register.sector === 'Voluntary Contributor'" class="text-muted">(Optional)</span>
                        <span v-else class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-center flex-wrap" style="gap: 10px;">
                        <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                          <i class="fe fe-camera mr-1"></i> Capture Photo
                        </button>
                        <button v-if="register.user_image && photoOriginal" class="btn btn-outline-secondary btn-sm"
                          type="button" @click="cropPhoto(photoOriginal)">
                          <i class="fe fe-crop"></i> Adjust
                        </button>
                        <button v-if="register.user_image" class="btn btn-outline-danger btn-sm" type="button"
                          @click="removePhoto">
                          <i class="fe fe-x"></i> Remove
                        </button>
                      </div>

                      <div v-if="register.user_image" class="mt-3">
                        <img :src="register.user_image" alt="Enrollee photo"
                          style="width: 130px; height: 167px; object-fit: cover; border-radius: 6px; border: 2px solid #dee2e6;" />
                        <p class="text-success small mt-1"><i class="fe fe-check-circle mr-1"></i>Photo ready</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <button type="submit" class="btn btn-info btn-block">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
            <PhotoCropper ref="photoCropper" />
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import occupations from "@/json/occupations.json";
  import qualifications from "@/json/qualifications.json";
  import sectorsJson from "@/json/sectors_dynamic.json";
  import vulnerablesJson from "@/json/vulnerables.json";
  import subProgramsJson from "@/json/sub_programs.json";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";

  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Loading,
      PhotoCropper,
    },
    data() {
      return {
        photoOriginal: "",
        agency: agency,
        user: null,
        label: {
          place_of_work_label: agency.id == "930972" ? "SDA" : "MDA",
        },
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        clients: "",
        providers: "",
        sector: "informal",
        mdas: "",
        wards: "",
        sectors: "",
        vulnerables: "",
        occupations: occupations,
        qualifications: qualifications,
        tpas: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        lga_states: "",
        response: "",
        register: {
          user_image: "",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          email: "",
          phone_number: "",
          plan_type: "Individual",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: "",
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "",
          sectorType: "",
          finger_print: "",
          place_of_work: "",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    mounted() {
      this.user = JSON.parse(localStorage.getItem("user"));

      //get Agency By ID
      let sectors = sectorsJson;
      let formatter = sectors.filter(
        (x) => x.agency_id == this.agency.id && x.type == 'informal'
      );

      //filter for BHCPF Staff
      if (this.isBHCPFStaff) {
        formatter = formatter.filter(
          (x) => x.name === 'Basic Healthcare Provision Fund'
        );
        this.register.sector = "Basic Healthcare Provision Fund"
        this.getMDAs();
      }

      this.sectors = formatter;

      //get Vulnerables By sector + agency
      this.filterVulnerable();
    },

    computed: {
      is313923() {
        return String(agency.id) === '313923';
      },
      isBHCPFStaff() {
        return this.user && this.user.job_title === 'Enrollment_BHCPF';
      },
      currentSubPrograms() {
        const map = subProgramsJson[String(agency.id)] || {};
        return map[this.register.sector] || [];
      },
      categoryLower() {
        return (this.register.category_of_vulnerable_group || '').toLowerCase();
      },
      isChildUnder5Category() {
        return this.categoryLower.includes('under 5');
      },
      isAgedCategory() {
        return this.categoryLower === 'aged' || this.categoryLower === 'elderly' || this.categoryLower === 'retirees';
      },
      isPregnantCategory() {
        return this.categoryLower.includes('pregnant');
      },
      dobMin() {
        if (this.isChildUnder5Category) {
          const d = new Date();
          d.setFullYear(d.getFullYear() - 5);
          return d.toISOString().slice(0, 10);
        }
        return '1900-01-01';
      },
      dobMax() {
        const today = new Date();
        if (this.isChildUnder5Category) {
          return today.toISOString().slice(0, 10);
        }
        if (this.isAgedCategory) {
          const d = new Date(today);
          d.setFullYear(d.getFullYear() - 60);
          return d.toISOString().slice(0, 10);
        }
        if (this.isPregnantCategory) {
          const d = new Date(today);
          d.setFullYear(d.getFullYear() - 13);
          return d.toISOString().slice(0, 10);
        }
        return today.toISOString().slice(0, 10);
      },
    },
    watch: {
      'register.category_of_vulnerable_group'(newVal) {
        if ((newVal || '').toLowerCase().includes('pregnant')) {
          this.register.gender = 'Female';
        }
      },
    },
    methods: {
      submitForm() {
        if (!this.register.occupation || !this.register.education || !String(this.register.address || "").trim()) {
          this.$toasted.error("Address, Occupation and Highest Qualification are required before submitting", {
            position: "top-center",
            duration: 4000,
          });
          return;
        }
        if (this.user.type == "employee") {
          const imageRequired = this.register.sector !== "Voluntary Contributor";
          if (this.register.provider_id != "" && (!imageRequired || this.register.user_image != "")) {
            this.registerUserEmployee();
          } else {
            this.$toasted.error(`Facility${imageRequired ? ' and picture are' : ' is'} required before submitting`, {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
            this.getProvidersByLGAs();
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getDepts() {
        this.register.org_id = this.register.place_of_work.hmo_id;
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/${agency.id}`, {
            params: {
              type: this.register.sector
            },
          })
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/${agency.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${agency.id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            user_image: this.register.user_image,
            agency_id: this.user.institutional_id,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            plan_type: this.register.plan_type,
            type: this.register.type,
            sectorType: this.register.sectorType,
            provider_id: this.register.provider_id.id,
            state: agency.state,
            role: 0,
            password: "euhler",
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            expiry_date: this.register.expiry_date,
            address1: this.register.address,
            genotype: this.register.genotype,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work.name,
            org_id: this.register.org_id,
            point_of_care: this.register.provider_id.id,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            occupation: this.register.occupation,
            education: this.register.education,
            community: this.register.community,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 10000,
            });

            // this.clearForm();


            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
            // this.$router.push(`/add-client-agency`);
            // window.location.href = '/add-client-agency';

          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            const data = error.response && error.response.data;
            let message;
            if (data && data.errors) {
              this.response = data.errors;
              message = JSON.stringify(data.errors);
            } else if (data && data.message) {
              message = data.message;
            } else {
              message =
                "Could not reach the server. If you attached a photo, try a smaller one, then check your connection and submit again.";
            }
            this.$toasted.error(message, {
              position: "top-center",
              duration: 6000,
            });
          });
      },
      clearForm() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        this.register.user_image = ""
        this.register.firstname = ""
        this.register.lastname = ""
        this.register.middlename = ""
        this.register.nimc_number = ""
        this.register.email = ""
        this.register.phone_number = ""
        this.register.plan_type = "Individual"
        this.register.type = "client"
        this.register.state = ""
        this.register.localgovt = ""
        this.register.ward = ""
        this.register.address = ""
        this.register.blood = ""
        this.register.gender = ""
        this.register.genotype = ""
        this.register.dob = ""
        this.register.expiry_date = ""
        this.register.salary_number = ""
        this.register.provider_id = ""
        this.register.point_of_care = ""
        this.register.sector = ""
        this.register.finger_print = ""
        this.register.place_of_work = ""
        this.register.org_id = ""
        this.register.grade_level = ""
        this.register.date_of_entry = ""
        this.register.marital_status = ""
        this.register.category_of_vulnerable_group = ""
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/${agency.id}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${agency.id}/${this.register.localgovt}/${this.register.ward}`
          )
          .then((response) => {
            this.providers = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByLGAs() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${agency.id}/${this.register.localgovt}`
          )
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },


      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Prompt,
            format: "jpeg",
          });
          if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
          this.$toasted.info("Photo captured successfully!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera.", {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      attachPic(event) {
        let imageFile = event.target.files[0];
        event.target.value = "";

        if (imageFile) {
          const reader = new FileReader();

          reader.onload = (e) => this.cropPhoto(e.target.result);

          reader.readAsDataURL(imageFile);
        }
      },
      // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.register.user_image = cropped;
        return true;
      },
      removePhoto() {
        this.register.user_image = "";
        this.photoOriginal = "";
      },
      onSectorChange() {
        this.register.sectorType = "";
        this.filterVulnerable();
      },
      filterVulnerable() {
        let vulnerables = vulnerablesJson;
        let formatterVulnerables = vulnerables.filter(
          (x) => x.agency_id == this.agency.id && x.sector == this.register.sector
        );
        this.vulnerables = formatterVulnerables;
        this.register.category_of_vulnerable_group = "";
        this.register.dob = "";
      }

    },

    created() {
      this.getTPAs();
      this.fetchLga();
      this.getMDAs();
    },
  };
</script>